import { SendEmailIcon } from "@/constant/imagePath";
import IconButton from "..";

const SendEmailButton = ({
  icon = SendEmailIcon,
  borderColor = "#7B4DB0",
  fromColor = "#C39BF8",
  toColor = "#7B4DB0",
  buttonStyle = { padding: "4.5px 2.6px" },
  onClick = null,
  tooltipText = "Send Email",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default SendEmailButton;
